export default __webpack_public_path__ + "static/media/x_icon.24a54a66.svg";